import Cookies from './cookie.js';
import './nav.js';

window.Cookies = Cookies;

var cookieTime = 1 / ( 24 * 60 ); // 1 min

$( function () {
  AOS.init();

  //open all external links in new tab
  $( 'a' ).each( function () {
    var a = new RegExp( '/' + window.location.host + '/' );
    if ( !a.test( this.href ) ) {
      $( this ).click( function ( event ) {
        event.preventDefault();
        event.stopPropagation();
        this.setAttribute( 'rel', 'noreferrer' );
        window.open( this.href, '_blank' );
      } );
    }
  } );

  $( 'a' ).click( function ( evt ) {
    if ( $( evt.target ).attr( 'href' ) === '#' ) {
      evt.preventDefault();
    }
  } );

  // Replace footnote text with number and create popover for it
  //Reverted to click trigger, as busted on mobile, since this and marksjs end up closing one another
  //TODO allow hover on desktop, and close on bodyclick
  var popovers = $( '[data-toggle="popover"]' );
  if ( popovers.length ) {
    for ( var i = 0; i < popovers.length; i++ ) {
      var content = $( popovers[ i ] ).html(),
        num = +i + 1;
      $( popovers[ i ] )
        .data( 'content', content )
        .text( '[' + num + ']' )
        .popover( {
          html: true
        } )
        .click( function ( evt ) {
          //evt.preventDefault();
          console.log('popover clicked');
          popovers.not( $( this ) ).popover( 'hide' );
        } )
        // .hover( function () {
        //   if ( !$( this ).attr( 'aria-describedby' ) ) {
        //     $( '.popover' ).popover( 'hide' );
        //     popovers.not( $( this ) ).popover( 'hide' );
        //     $( this ).popover( 'show' );
        //   }
        // } );
    }
  }

  // $( 'body' )
  //   .click( function ( evt ) {
  //     $( '.popover' ).popover( 'hide' );
  //     popovers.popover( 'hide' );
  //   } )
  //   .on( 'touchstart', function ( evt ) {
  //     evt = $( evt.target );
  //     if ( !evt.attr( 'href' ) ) {
  //       $( '.popover' ).popover( 'hide' );
  //     }
  //   } );

  // Smooth scroll for jump links and if it links to accordion, open that accordion
  $( 'a' ).click( function ( evt ) {
    if ( this.hash !== '' && this.hash != '#process-carousel' ) {
      if ( !$( this ).data( 'toggle' ) ) {
        var target = $( this.hash );
        target = target.length ? target : false;
        // Does a scroll target exist?
        if ( target.length ) {
          // Only prevent default if animation is actually gonna happen
          evt.preventDefault();
          $( 'html, body' ).animate( {
              scrollTop: target.offset().top - 100
            },
            500
          );
        }
      }
      if ( $( this.hash ).hasClass( 'panel-heading' ) ) {
        $( '#collapse-' + this.hash.substr( 1 ) ).collapse( 'show' );
      }
    }
  } );

  //  Make panel headings open panel
  $( '.panel-heading' ).click( function ( evt ) {
    var panelId = $( evt.target ).find( 'a' ).length ?
      $( evt.target ).find( 'a' )[ 0 ].hash :
      $( evt.target )
      .closest( '.panel-heading' )
      .find( 'a' )[ 0 ].hash;

    $( panelId ).collapse( 'toggle' );
  } );

  $( 'article .checkbox, .article .checkmark' ).click( function ( evt ) {
    evt.preventDefault();
    var tile = $( evt.target ).closest( 'article' );
    if ( tile.hasClass( 'cause' ) ) {
      var tileId = '#' + tile.attr( 'id' );
      $( '#filters #causes article' )
        .not( tileId )
        .find( '.checkbox' )
        .removeClass( 'checked' );
    }
    $( evt.target )
      .closest( '.checkbox' )
      .toggleClass( 'checked' );
  } );

  $( '#yogaModal' ).on( 'show.bs.modal', function ( evt ) {
    var button = $( evt.relatedTarget ),
      slideId = button.data( 'slideTo' ) - 1,
      slides = $( '#yoga-carousel .carousel-inner .item' ),
      indicators = $( '#yoga-carousel li' );
    slides.removeClass( 'active' );
    indicators.removeClass( 'active' );
    $( slides[ slideId ] ).addClass( 'active' );
    $( indicators[ slideId ] ).addClass( 'active' );
  } );

  // glossary terms
  var contentBlocks = new Mark( $( '#main' ).find( '.content_block, .accordion' ) );
  $.each( glossary.terms, function ( i, term ) {
    term.string = term.post_title.toLowerCase();
    contentBlocks.mark( term.string, {
      accuracy: {
        value: 'exactly',
        limiters: [ ' ', ',', '.' ]
      },
      element: 'span',
      separateWordSearch: false,
      exclude: [ '.panel-title *', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' ],
      caseSensitive: false,
      each: function ( marked ) {
        // if (!marked.closest('.panel-title, h1, h2, h3')) {
        $( marked )
          .css( {
            'text-decoration': 'underline',
            'text-decoration-style': 'dotted',
            'background-color': 'rgb(255, 251, 204)',
            cursor: 'pointer'
          } )
          .popover( {
            title: term.post_title,
            template: '<div class="popover glossary-term" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div><a href="' +
              term.permalink +
              '" title="' +
              term.post_title +
              '">Learn More</a></div>',
            placement: 'top',
            content: term.custom_excerpt,
            trigger: 'click'
          } )
          // .on( 'mouseover', function () {
          //   if ( !$( this ).attr( 'aria-describedby' ) ) {
          //     $( '.popover' ).popover( 'hide' );
          //     $( this ).popover( 'show' );
          //   }
          // } )
          // .on( 'touchstart', function () {
          //   if ( !$( this ).attr( 'aria-describedby' ) ) {
          //     $( '.popover' ).popover( 'hide' );
          //     $( this ).popover( 'show' );
          //   }
          // } );
        // }
      }
    } );
  } );

  // Hotline
  var hotline = $( '#hotline' );
  if ( hotline.length > 0 ) {
    var hotlineShown = window.sessionStorage.getItem( 'hotlineShown' ) ? window.sessionStorage.getItem( 'hotlineShown' ) : false;
    // var hotlineShown = Cookies.get('hotlineShown') ?
    //   Cookies.get('hotlineShown') :
    //   false;
    var showHotline = false,
      hideHotLine = false;
    var hotlineOpen = function () {
      var openWidth =
        hotline.find( '.link a' ).outerWidth() +
        hotline.find( '.icon' ).outerWidth() +
        60;
      hotline
        .removeClass( 'min' )
        .addClass( 'max' )
        .animate( {
          width: openWidth
        }, 500 );
    };

    var hotlineClose = function () {
      hotline
        .removeClass( 'max' )
        .addClass( 'min' )
        .animate( {
            width: 50
          },
          500
        );
    };

    hotline.find( '.icon' ).click( function () {
      clearTimeout( showHotline );
      clearTimeout( hideHotLine );
      if ( hotline.hasClass( 'min' ) ) {
        hotlineOpen();
      } else {
        hotlineClose();
      }
    } );

    if ( !hotlineShown ) {
      // var in24hours = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      // Cookies.set('hotlineShown', true, {
      //   expires: in24hours
      // });
      window.sessionStorage.setItem( 'hotlineShown', true );
      // var showHotline = setTimeout(function () {
      hotlineOpen();
      var hideHotLine = setTimeout( function () {
        hotlineClose();
      }, 5000 );
      // }, 2000);
    }
  }


  // Email Modal on front page only
  if(window.location.pathname === '/') {
    console.log('window.location.pathname: ', window.location.pathname);
    var showNewsletterSignup = Cookies.get( 'showNewsletterSignup' ) ? Cookies.get( 'showNewsletterSignup' ) : false;
    if ( !showNewsletterSignup ) {
      $( '#emailModal' ).modal( {
        show: false
      } );
      var show = false;

      $( window ).scroll( function () {
        if ( $( window ).scrollTop() > $( 'body' ).height() / 3 ) {
          if ( !show ) {
            $( '#emailModal' ).modal( 'show' );
            show = true;
          }
        }
      } );
      var in30days = new Date( new Date().getTime() + 24 * 60 * 60 * 1000 * 30 );
      Cookies.set( 'showNewsletterSignup', true, {
        expires: in30days
      } );
    }
  }
} );

( function ( $ ) {
  $( 'document' ).ready( function () {
    //Mobile caret trigger
    $( '.dropdown .caret' ).click( function ( e ) {
      e.stopPropagation();
      $( '.dropdown' ).toggleClass( 'open' );
    } );
  } );

  var docWidth = document.documentElement.offsetWidth;
  [].forEach.call(
    document.querySelectorAll( '*' ),
    function ( el ) {
      if ( el.offsetWidth > docWidth ) {
        console.log( el );
      }
    }
  );
} )( jQuery );